import React, { FC } from 'react';
import classnames from 'classnames';
import { BoxSeam } from 'react-bootstrap-icons';

import { IStock } from 'api/types';

import styles from 'theme/components/controls/wise/WiseAvailability/WiseAvailability.module.scss';

interface IProps {
  stock: IStock;
}

const WiseAvailability: FC<IProps> = ({ stock }) => (
  <div
    className={classnames(styles.componentWrapper, styles[stock.type], 'StylePath-Components-Controls-Availability')}>
    <BoxSeam />
    <span className={styles.label} dangerouslySetInnerHTML={{ __html: stock.name as string }} />
  </div>
);

export default WiseAvailability;
